import { getRawQueryParams } from './appParams'

export const UPLOAD_ROUTE = '/upload'

const currentPath = (globalThis.location?.pathname ?? '/').replace(/\/+$/, '') || '/'

// Single-file builds and the extra html entries (playground, config, debug-inputs)
// are served as one standalone document, so path-based routing doesn't apply there.
const unrouted = process.env.SINGLE_FILE_BUILD === 'true'
  || globalThis.location?.protocol === 'file:'
  || currentPath.endsWith('.html')

/** The root only serves link traffic (`/?replayFileUrl=...`); a bare `/` is a 404. */
export const isNotFoundRoute = !unrouted
  && currentPath !== UPLOAD_ROUTE
  && !(currentPath === '/' && [...getRawQueryParams().keys()].length > 0)
